module.exports = __webpack_public_path__ + "static/media/iphone.67bced32.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/products/iphone.jpg
// module id = 1803
// module chunks = 11